import React, { useState, useMemo, useEffect } from 'react';
import { OptionsType } from '../../utils/customSelectUtils';
import { commonBackInfo } from '../../utils';
import CustomSelect from '../../components/CustomSelect';
import type { SingleCommonType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { typeOfCoveragePlaceholder } from '../../constants/placeholder';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import './index.scss';

export default function NewsCoverageTypeSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  lang,
}: SingleCommonType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const basicOptions = useMemo(() => {
    if (filterOptions) {
      return (filterOptions || [])?.map((item: string) => {
        return {
          text: item,
          value: item,
        };
      });
    }
    return [];
  }, [filterOptions]);
  const { formatMessage } = useIntl();

  const options: OptionsType = useMemo(() => {
    return basicOptions.filter((item: { text: string }) => {
      if (!searchValue) return true;

      return item.text.toLowerCase().includes(searchValue.toLowerCase());
    });
  }, [basicOptions, searchValue, lang]);

  const {
    selects: newsCoverageType,
    setSelects: setNewsCoverageType,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'news_coverage_type',
    options: basicOptions?.map((item: any) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    let news_coverage_type = isAll ? [] : newsCoverageType;

    onChange?.(
      'newsCoverageType',
      commonBackInfo(
        { news_coverage_type },
        { newsCoverageType: text },
        { isAll, needChangeEntity: true },
      ),
    );
  }, [newsCoverageType, formatMessage]);

  return (
    <div className={`news_coverage_type-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={typeOfCoveragePlaceholder[lang]}
        options={options}
        basicOptions={basicOptions}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[newsCoverageType, setNewsCoverageType]}
        onClear={() => setNewsCoverageType([])}
        pointKey={FilterButtonPoint.newsCoverageType}
        boxClassName="news-coverage-type-select"
      ></CustomSelect>
    </div>
  );
}
